import { apiSlice } from '@/api';
import {
  Ad,
  AdDetailsResponse,
  AdPreviewResponse,
  CreateAd,
  ReviewStatus,
  UpdateAd,
} from './types';

export const adApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAd: builder.query<AdDetailsResponse, { id: string }>({
      query: ({ id }) => ({
        url: `v1/ad/${id}`,
        method: 'GET',
      }),
      transformResponse: (response: { result: AdDetailsResponse }) =>
        response.result,
    }),
    getZoneAds: builder.query<Ad[], { zoneId: number }>({
      query: ({ zoneId }) => ({
        url: `/v1/zone/${zoneId}/ads`,
        method: 'GET',
      }),
    }),
    getUserAds: builder.query<
      AdPreviewResponse[],
      { reviewStatus: ReviewStatus }
    >({
      query: ({ reviewStatus }) => {
        return `v1/user/profile/ads?reviewStatus=${reviewStatus}`;
      },
      transformResponse: (response: { result: AdPreviewResponse[] }) =>
        response.result,
    }),
    getCampaignAds: builder.query<AdPreviewResponse[], { campaignId: string }>({
      query: ({ campaignId }) => {
        return `v1/ad/campaign/${campaignId}`;
      },
      transformResponse: (response: { result: AdPreviewResponse[] }) =>
        response.result,
    }),
    createAd: builder.mutation<
      { result: AdPreviewResponse },
      Omit<CreateAd, 'price'>
    >({
      query: (body) => ({
        url: 'v1/ad',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Ad'],
    }),
    updateAd: builder.mutation<
      { result: AdPreviewResponse },
      { ad: UpdateAd; id: string }
    >({
      query: ({ ad, id }) => ({
        url: `v1/ad/${id}`,
        method: 'PUT',
        body: ad,
      }),
      invalidatesTags: (__, _, args) => [{ type: 'Ad', id: args.id }],
    }),
    deleteAd: builder.mutation<{ result: AdPreviewResponse }, { id: string }>({
      query: ({ id }) => {
        return {
          url: `v1/ad/${id}`,
          method: 'DELETE',
        };
      },
      invalidatesTags: (__, _, args) => [{ type: 'Ad', id: args.id }],
    }),
  }),
});

export const {
  useGetAdQuery,
  useCreateAdMutation,
  useLazyGetZoneAdsQuery,
  useGetUserAdsQuery,
  useUpdateAdMutation,
  useDeleteAdMutation,
  useGetCampaignAdsQuery,
} = adApi;
